function categoryInit() {

    if ($('.sidebar.sidebar-left .pagination-count').length === 0) {
        $('.sidebar.sidebar-left').prepend($('.pagination-count'))
    }

    if ($('#content-wrapper > .category-top').length === 0) {
        $('.breadcrumbs').after($('.category-top'))
    }

    $('.subcategories.with-image > li').removeClass().addClass('subcategory')
}

